'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var nthHookTheme = require('@narvar/nth-hook-theme');
var Action_module = require('./Action.module.css.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const Action = props => {
  const {
    icon,
    text,
    onClick
  } = props;
  const {
    bodytextDefaultNone,
    buttonsPrimaryDefault
  } = nthHookTheme.useTheme();
  const handleClick = () => {
    onClick();
  };
  const handleKeyDown = event => {
    if (event.key !== '[enter]') return;
    onClick();
  };
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: Action_module["default"].container,
    role: "button",
    tabIndex: 0,
    onClick: handleClick,
    onKeyDown: handleKeyDown,
    style: buttonsPrimaryDefault
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: Action_module["default"].icon
  }, icon), /*#__PURE__*/React__default["default"].createElement("p", {
    className: Action_module["default"].text,
    style: {
      ...bodytextDefaultNone,
      color: 'white'
    }
  }, text));
};
var Action$1 = nthHookTheme.withThemeProvider(Action, {
  themeTokens: ['bodytextDefaultNone', 'buttonsPrimaryDefault']
});

exports["default"] = Action$1;
